
import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { Col, Row } from 'reactstrap';
import '../assets/css/PriorityStyle.css'; // Import the external styles
import { SEND_SINGLE_PRIORITY_TRANSACTION } from '../graphql/mutations/priority';

const PaymentForm = () => {
  const [formError, setformError] = useState(null);
  const [paymentPending, setPaymentPending] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(null);

  //start of custom stuff
  const [loading, setLoading] = useState(false);
  const [sendSinglePriorityTransaction] = useMutation(SEND_SINGLE_PRIORITY_TRANSACTION);
  const [cardData, setCardData] = useState({
    cardNumber: '',
    expMonth: '',
    expYear: '',
    cardCode: '',
    zipCode: '',
  });

  const SendIFrameMessage = (data, action) => {
    window.parent.postMessage({ type: 'FROM_IFRAME', payload: { data: data, action: action } }, process.env.REACT_APP_WOWCLOUD_PARENT + '/checkout/ed00261a-87f6-4744-8915-e2d4f40b1111'); //Parent
  }

  useEffect(() => {
    const handleIframeMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_WOWCLOUD_PARENT) return; //Parent
  
      const { type, payload } = event.data;
      if (type === 'FROM_PARENT') {
        if(payload.action === "SendBillingData"){
          const serverPayload = {
            token: encodeCardPayload(cardData.cardNumber, cardData.cardCode),
            paymentdata: {
              firstname: payload.data.firstname,
              lastname: payload.data.lastname,
              address: payload.data.address1,
              address2: payload.data.address2,
              city: payload.data.city,
              state: payload.data.state,
              zip: parseInt(payload.data.zip),
              phone: payload.data.phone,
              email: payload.data.email,
              country: "US",
              price: parseInt(payload.data.price),
              expMonth: parseInt(cardData.expMonth),
              expYear: parseInt(cardData.expYear),
              lastFour: parseInt(cardData.cardNumber.replace(/\D/g, "").slice(-4)),
              processorTransactionId: null, //"theCardToken.id", //TODO: ?????????
              bin: "",
              paymentid: payload.data.paymentid,
              productid: payload.data.productid,
              refid: payload.data.refid,
              shortdescription: payload.data.shortdescription,
              existingcustomer: payload.data.existingcustomer,
              referral: payload.data.referral,
            }
          }

          SendSingleTransaction(serverPayload)
        }
        else if(payload.action == "Reset"){
          setLoading(false);
        }
      }
    };
  
    window.addEventListener('message', handleIframeMessage);
  
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [paymentPending]);

  const SendSingleTransaction = (serverPayload) => {
    sendSinglePriorityTransaction({ variables: {token: serverPayload.token, paymentdata: serverPayload.paymentdata}})
    .then((tres) => {
      if(tres.data.sendSinglePriorityTransaction.status){
        SendIFrameMessage(tres.data.sendSinglePriorityTransaction.data, "TransactionSuccess")
        // setLoading(false);
      }
      else{
        if(tres.data.sendSinglePriorityTransaction.error === "CardValidationRequired"){
          SendIFrameMessage(tres.data.sendSinglePriorityTransaction.error, "CardValidationRequired")
          setLoading(false);
        }
        else{
          SendIFrameMessage(tres.data.sendSinglePriorityTransaction.error, "TransactionError")
          setLoading(false);
        }
      }
    })
    .catch((err) => {
      console.log("ERROR2", err)
      
    })
    .finally(() =>{
      //TODO: Set loading
      handleReset();
    })
  }
  //end of custom stuff

  const isValidCardNumber = (cardNumber) => {
    const cleaned = cardNumber.replace(/\D/g, "");
    if (cleaned.length < 13 || cleaned.length > 19) return false;
    let sum = 0;
    let shouldDouble = false;

    for (let i = cleaned.length - 1; i >= 0; i--) {
      let digit = parseInt(cleaned[i]);
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0;
  };

  const isValidMonth = (month) => {
    return /^(0[1-9]|1[0-2])$/.test(month);
  };

  const encodeCardPayload = (cardNumber, cardCode) => {
    const raw = `${cardNumber.replace(/\s/g, '')}%${cardCode}`;
    return btoa(raw); // Base64 encode
  };

  const isValidYear = (year) => {
    if (!/^\d{2}$/.test(year)) return false;
    const currentYear = new Date().getFullYear() % 100; // e.g. 2025 → 25
    return parseInt(year) >= currentYear;
  };

  const isValidCVV = (cvv) => /^\d{3}$/.test(cvv);
  const isValidZip = (zip) => /^\d{5}$/.test(zip);


  const handleSubmit = async (event) => {
    event.preventDefault();

    const cleanedCardNumber = cardData.cardNumber.replace(/\s/g, "");

    if (!isValidCardNumber(cleanedCardNumber)) {
      setformError("Invalid card number.");
      return;
    }

    if (!isValidMonth(cardData.expMonth)) {
      setformError("Invalid expiration month.");
      return;
    }

    if (!isValidYear(cardData.expYear)) {
      setformError("Invalid expiration year.");
      return;
    }

    if (!isValidCVV(cardData.cardCode)) {
      setformError("Invalid CVC code.");
      return;
    }

    if (!isValidZip(cardData.zipCode)) {
      setformError("Invalid zip code.");
      return;
    }

    setformError(null); // clear error
    setLoading(true);
    setPaymentPending(true);

    setTimeout(() => {
      SendIFrameMessage(null, "SendBillingData");
    }, 1000);
  };

  const handleReset = () => {
    //TODO: Deal with form reset
    setCardData({
      cardNumber: '',
      expMonth: '',
      expYear: '',
      cardCode: '',
      zipCode: '',
    })
  };

  const validateWholeNumber = (value) => {
    const wholeNumberRegex = /^\d*$/; // Regular expression to match whole numbers
    return wholeNumberRegex.test(value)
  };

  return (
  <div className ="mwContainer">
    {loading &&
      <Row>
        <Col md = "12">
          <h1>Processing ...</h1>
        </Col>
      </Row>
    } 
      
    {!loading &&
      <div>
        <form onSubmit={handleSubmit} className="payment-form">
          {/* Card Number */}
          <div className="field">
            <label className="field-label center">Card Number</label>
            <input
              type="text"
              className="form-control StripeElement"
              name="cardNumber"
              value={cardData.cardNumber}
              placeholder="1234 1234 1234 1234"
              onChange={(e) => {
                const raw = e.target.value.replace(/\D/g, "").slice(0, 16);
                const formatted = raw.match(/.{1,4}/g)?.join(" ") || "";
                setCardData({ ...cardData, cardNumber: formatted });
              }}
            />
          </div>

          {/* 3-column row */}
          <div className="row-3">
            {/* Exp Date */}
            <div className="field">
              <label htmlFor="expMonth" className="field-label">Exp Date</label>
              <div className="date-input" role="group" aria-label="Expiration date">
                <input
                  type="text"
                  className="date-segment"
                  name="expMonth"
                  maxLength={2}
                  value={cardData.expMonth}
                  placeholder="MM"
                  onChange={(e) => {
                    let val = e.target.value.replace(/\D/g, "");

                    if (val.length === 1 && parseInt(val) > 1) {
                      val = "0" + val;
                    }

                    if (val.length === 2) {
                      const num = parseInt(val, 10);
                      if (num < 1 || num > 12) return;
                      val = num.toString().padStart(2, "0");
                    }

                    setCardData({ ...cardData, expMonth: val });
                  }}
                  onBlur={(e) => {
                    let val = e.target.value.replace(/\D/g, "");

                    if (!val) return;

                    const num = parseInt(val, 10);
                    if (isNaN(num) || num < 1 || num > 12) return;

                    val = num.toString().padStart(2, "0");
                    setCardData({ ...cardData, expMonth: val });
                  }}
                />

                <span className="separator">/</span>
                <input
                  type="text"
                  className="date-segment"
                  name="expYear"
                  maxLength={2}
                  value={cardData.expYear}
                  placeholder="YY"
                  onChange={(e) => {
                    if (validateWholeNumber(e.target.value))
                      setCardData({ ...cardData, expYear: e.target.value })
                  }}
                />
              </div>
            </div>

            {/* CVC */}
            <div className="field">
              <label htmlFor="cardCode" className="field-label">CVC</label>
              <input
                type="text"
                className="small-input"
                name="cardCode"
                maxLength={3}
                placeholder="CVC"
                value={cardData.cardCode}
                onChange={(e) => {
                  if (validateWholeNumber(e.target.value))
                    setCardData({ ...cardData, cardCode: e.target.value })
                }}
              />
            </div>

            {/* Zip Code */}
            <div className="field">
              <label htmlFor="zipCode" className="field-label">Zip Code</label>
              <input
                type="text"
                className="small-input"
                name="zipCode"
                placeholder=""
                maxLength={5}
                value={cardData.zipCode}
                onChange={(e) => {
                  if (validateWholeNumber(e.target.value))
                    setCardData({ ...cardData, zipCode: e.target.value })
                }}
              />
            </div>
          </div>

          {/* Pay button */}
          <button type="submit" className="submit-btn" disabled={loading}>
            Pay
          </button>

          {/* Error */}
          <div className="error-message">
            {formError && <p>{formError}</p>}
          </div>
        </form>

      </div>
    }
  </div>
  );
};

function PriorityPayment() {
    return (
      <div className="mwContainer">
        <PaymentForm />
      </div>
  )
}

export default PriorityPayment;